<template>
  <form @submit.prevent="submit">
    <fieldset :disabled="disabled">
      <div class="form-group">
        <label
          class="form-label"
          for="profile-name"
        >
          Имя
        </label>

        <input
          id="profile-name"
          v-model="name"
          class="form-input"
          autocomplete="given-name"
          required
        />
      </div>

      <div class="form-group">
        <label
          class="form-label"
          for="profile-surname"
        >
          Фамилия
        </label>

        <input
          id="profile-surname"
          v-model="surname"
          class="form-input"
          autocomplete="family-name"
          required
        />
      </div>

      <button
        class="settings-submit"
        :disabled="!hasChanges"
        type="submit"
      >
        {{ getSubmitBtnText}}
      </button>
    </fieldset>
  </form>
</template>

<script>
export default {
  name: 'ProfileForm',
  props: {
    user: {
      type: Object,
      required: true
    },
    disabled: Boolean,
    saving: Boolean
  },
  data () {
    return {
      name: '',
      surname: ''
    }
  },
  computed: {
    hasChanges () {
      return this.name.trim() && this.surname.trim() &&
        (this.name.trim() !== this.user.name || this.surname.trim() !== this.user.surname)
    },
    getSubmitBtnText () {
       return this.saving ? 'Сохранение…' : 'Сохранить имя и фамилию'
    }
  },
  watch: {
    user: {
      immediate: true,
      handler (user) {
        this.name = user.name || ''
        this.surname = user.surname || ''
      }
    }
  },
  methods: {
    submit () {
      if (this.disabled || !this.hasChanges) {
        return
      }

      this.$emit('save', { name: this.name.trim(), surname: this.surname.trim() })
    }
  }
}
</script>
